<template>
  <div class="animated fadeIn">
    <basic-heading title="Submissions" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list submission'">
      <template #gated-content>
        <b-row class="px-0 m-0 bg-light my-3">
          <b-col
            v-for="(indicator, index) in indicators"
            :key="index"
            :class="`px-${index === 1 ? 3 : 0}`"
          >
            <indicator-tile
              :text="indicator.text"
              :indicator_key="indicator.indicator_key"
              :faIcon="indicator.faIcon"
              :variant="indicator.variant"
            />
          </b-col>
        </b-row>
        <submission-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import IndicatorTile from "@/components/shared/IndicatorTile";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import StatisticTile from "@/components/shared/StatisticTile";
import SubmissionServerTable from "@/components/lab/submission/SubmissionServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { submission_indicators } from "@/shared/_indicators";

export default {
  name: "SubmissionIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    IndicatorTile,
    PermissionAlertGate,
    StatisticTile,
    SubmissionServerTable,
  },
  data() {
    return {
      indicators: submission_indicators,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
        ],
        dropdown: {
          items: [
            {
              icon: "fa-shovel",
              linkto: `/submissions/apply-test-package`,
              text: "Apply A Test package",
              variant: "info",
            }
          ],
        },
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
